import { createContext } from "react";
export const DescriptionContext = createContext();
export default DescriptionContext;